import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AgentDetail from "@/pages/AgentDetail";
import AuthCallback from "@/pages/AuthCallback";
import PublicChat from "@/pages/PublicChat";
import BillingSuccess from "@/pages/BillingSuccess";
import ServicesPage from "@/pages/ServicesPage";
import { BlogIndex, BlogPost } from "@/pages/Blog";
import { AboutPage, ContactPage } from "@/pages/AboutContact";
import ComparePage from "@/pages/ComparePage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import HelpIndex from "@/pages/help/HelpIndex";
import WhatsAppGuide from "@/pages/help/WhatsAppGuide";
import MetaChannelsGuide from "@/pages/help/MetaChannelsGuide";
import {
  WebsiteWidgetGuide, ShareLinkGuide, KnowledgeBaseGuide,
  IntakeFormGuide, PauseAIGuide, CustomDomainGuide, BillingGuide,
} from "@/pages/help/HowToArticles";
import { PrivacyPolicy, TermsOfService, CookiePolicy, GDPRPage } from "@/pages/help/LegalPages";
import { LoginPage, SignupPage, VerifyEmailPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AuthPage";
import AdminBlogPage from "@/pages/AdminBlogPage";
import AdminHealthPage from "@/pages/AdminHealthPage";
import AdminVoicesPage from "@/pages/AdminVoicesPage";
import AdminBootstrapPage from "@/pages/AdminBootstrapPage";
import ClaimAdminPage from "@/pages/ClaimAdminPage";

function AppRouter() {
  const location = useLocation();
  // Synchronous check — process OAuth fragment BEFORE any other route
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/admin/blog" element={<AdminBlogPage />} />
      <Route path="/dashboard/admin/health" element={<AdminHealthPage />} />
      <Route path="/dashboard/admin/voices" element={<AdminVoicesPage />} />
      <Route path="/admin-bootstrap" element={<AdminBootstrapPage />} />
      <Route path="/claim-admin" element={<ClaimAdminPage />} />
      <Route path="/dashboard/agents/:id" element={<AgentDetail />} />
      <Route path="/chat/:token" element={<PublicChat />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/services" element={<ServicesPage />} />

      {/* Blog */}
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />

      {/* About & contact */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />

      {/* Competitor comparisons */}
      <Route path="/vs/:competitor" element={<ComparePage />} />

      {/* Affiliate leaderboard */}
      <Route path="/leaderboard" element={<LeaderboardPage />} />

      {/* Help center */}
      <Route path="/help" element={<HelpIndex />} />
      <Route path="/help/whatsapp" element={<WhatsAppGuide />} />
      <Route path="/help/meta-channels" element={<MetaChannelsGuide />} />
      <Route path="/help/website-widget" element={<WebsiteWidgetGuide />} />
      <Route path="/help/share-link" element={<ShareLinkGuide />} />
      <Route path="/help/knowledge-base" element={<KnowledgeBaseGuide />} />
      <Route path="/help/intake-form" element={<IntakeFormGuide />} />
      <Route path="/help/pause-ai" element={<PauseAIGuide />} />
      <Route path="/help/custom-domain" element={<CustomDomainGuide />} />
      <Route path="/help/billing" element={<BillingGuide />} />

      {/* Legal */}
      <Route path="/legal/privacy" element={<PrivacyPolicy />} />
      <Route path="/legal/terms" element={<TermsOfService />} />
      <Route path="/legal/cookies" element={<CookiePolicy />} />
      <Route path="/legal/gdpr" element={<GDPRPage />} />

      {/* Backward-compat redirect (in case anything links to the old URL) */}
      <Route path="/how-to/whatsapp" element={<WhatsAppGuide />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#1A1715",
                color: "#F5F2EB",
                border: "1px solid rgba(245,242,235,0.12)",
                borderRadius: "2px",
                fontFamily: "IBM Plex Mono, monospace",
              },
            }}
          />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
